import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Open_Sans\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"open\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/codebuild/output/src2403834457/src/faculdademetropolitana/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2403834457/src/faculdademetropolitana/src/app/formbricks.ts");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2403834457/src/faculdademetropolitana/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2403834457/src/faculdademetropolitana/src/components/apollo.wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2403834457/src/faculdademetropolitana/src/components/CookieConsentBanner.tsx");
